import { MessageTooltipAttribute, MessageTooltipScope } from "./qp-message-tooltip.interface";
import tpl from "./qp-message-tooltip.template.html";

export function QpMessageTooltip($translate: angular.translate.ITranslateService): ng.IDirective {
    return {
        restrict: 'EA',
        template: tpl,
        scope: {
            qpMsgTipTitle: '@',
            qpMsgTipPlacement: '@',
            qpMsgTipTrigger: '@',
            qpMsgTipCode: '@',
            qpMsgTipDsc: '@',
        },
        link: (
            scope: MessageTooltipScope,
            elements: JQLite,
            attrs: MessageTooltipAttribute,
            ctrl?: angular.IController,
            transcludeFn?: angular.ITranscludeFunction
        ) => {
            scope.qpMsgTipTitle = attrs.qpMsgTipTitle;
            scope.qpMsgTipPlacement = attrs.qpMsgTipPlacement || "bottom";
            scope.qpMsgTipTrigger = attrs.qpMsgTipTrigger || "mouseenter";

            if (attrs.qpMsgTipCode != null || attrs.qpMsgTipCode != undefined ||
                attrs.qpMsgTipDsc != null || attrs.qpMsgTipDsc != undefined
            ) {
                scope.qpMsgTipTrigger = "outsideClick";
            }

            scope.qpMsgTipCode = attrs.qpMsgTipCode;
            scope.qpMsgTipDsc = attrs.qpMsgTipDsc;

            scope.isCollapsed = true;
        }
    }
};


//-----------------------------------------------------
// SECTION - 2. 指令注入
//-----------------------------------------------------
QpMessageTooltip.$inject = ['$translate'];